import React from 'react'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { ContentLoader, Rect } from '@src/components/ContentLoader'

export const LoadingTimeSlot = () => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View style={styles.loadingSlot}>
      <ContentLoader width="100%" height="100%">
        <Rect x="0" y="0" width="100%" height="100%" rx="14" ry="14" />
      </ContentLoader>
    </View>
  )
}

const themedStyles = StyleService.create({
  loadingSlot: {
    height: 56,
    borderRadius: 40,
  },
})
